/** Cookie consent banner */
import { getCookie, setCookie } from './cookie'

export function initCookieConsent(): void {
  const tip = document.querySelector<HTMLElement>('.cookie-tip')
  if (!tip) return

  if (getCookie('cookieconsent_status')) {
    tip.classList.remove('active')
  } else {
    tip.classList.add('active')
  }

  document.getElementById('accept-tos')?.addEventListener('click', () => {
    setCookie('cookieconsent_status', 'allow', 365)
    tip.classList.remove('active')
  })
}
